var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10715_107498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C15 20.0544 14.1841 20.9182 13.1493 20.9945L13 21H11C9.94564 21 9.08183 20.1841 9.00548 19.1493L9 19H15ZM12.0002 2C15.7857 2 18.8693 5.00479 18.9961 8.75935L19.0002 9V12.7639L20.8222 16.4081C21.1705 17.1047 20.7047 17.9183 19.9532 17.9943L19.8384 18H4.16197C3.38319 18 2.8637 17.2195 3.13189 16.5134L3.1781 16.4081L5.00016 12.7639V9C5.00016 5.13401 8.13417 2 12.0002 2ZM12.0002 4C9.31141 4 7.11834 6.12231 7.00478 8.78311L7.00016 9V12.7639C7.00016 13.0123 6.95389 13.2579 6.86429 13.4885L6.78902 13.6584L5.6182 16H18.3821L17.2113 13.6584C17.1003 13.4362 17.0318 13.1957 17.0088 12.9495L17.0002 12.7639V9C17.0002 6.23858 14.7616 4 12.0002 4Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10715_107498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.fdc4dc6823d416a1185a8b98c1833ff2.svg";
export { ForwardRef as ReactComponent };